module.exports = __webpack_public_path__ + "static/media/21_zugeschnitten2.7dfbfe04.jpg";